import FormField from "components/FormField";
import MDModal from "components/MDModal";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import { useState } from "react";
// import Multiselect from "./components/Multiselect";
import { useUpdateAccount } from "queries/accounts";
import SoftMultiSelect from 'components/SoftMultiSelect'
import { Grid } from "@mui/material";

function ModalComponent({ open, onClose,apps, products,data,handleRefresh }) {
  const [formData, setFormData] = useState({
    _id: data._id || "",
    // first_name: data.first_name || "",
    last_name: data.last_name || "",
    email: data.email || "",
    business_name: data.business_name || "",
    address: data.address || "",
    city: data.city || "",
    country: data.country || "",
    state: data.state || "",
    zip_code: data.zip_code || "",
    phone_number: data.phone_number || "",
    time_zone: data.time_zone || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const { mutateAsync: updateAccount } = useUpdateAccount();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = formData;
    const { response } = await updateAccount(payload);
    if (response) {
      onClose();
    }
  };
 
  return (
    <MDModal open={open} onClose={onClose} styling={{ width: "95vw", minHeight: "85vh" }}>
      <SoftBox component="form" onSubmit={handleSubmit}>
        <SoftTypography component="h1" mb={3} variant="h5">
          Edit Account
        </SoftTypography>
        <Grid container spacing={2}>
          {/* <Grid item xs={6}>
            <SoftBox>
              <FormField label="Name" onChange={handleChange} placeholder="Name" name="first_name"  value={formData.first_name || ''}  />
            </SoftBox>
          </Grid> */}
          <Grid item xs={12}>
            <SoftBox>
              <FormField label="Business Name" onChange={handleChange} placeholder="Business Name" name="business_name" value={formData.business_name || ''} />
            </SoftBox>
          </Grid>
          <Grid item xs={6}>
            <SoftBox>
            <FormField label="Email" onChange={handleChange} placeholder="Email" name="email" value={formData.email || ''} />
            </SoftBox>
          </Grid>
          <Grid item xs={6}>
            <SoftBox>
              <FormField label="Address" onChange={handleChange} placeholder="Address" name="address"  value={formData.address || ''}/>
            </SoftBox>
          </Grid>
          <Grid item xs={6}>
            <SoftBox>
              <FormField label="City" onChange={handleChange} placeholder="City" name="city" value={formData.city || ''} />
            </SoftBox>
          </Grid>
          <Grid item xs={6}>
            <SoftBox>
              <FormField label="Country" onChange={handleChange} placeholder="Country" name="country"  value={formData.country || ''}/>
            </SoftBox>
          </Grid>
          <Grid item xs={6}>
            <SoftBox>
              <FormField label="State" onChange={handleChange} placeholder="State" name="state" value={formData.state || ''} />
            </SoftBox>
          </Grid>
          <Grid item xs={6}>
            <SoftBox>
              <FormField label="ZIP Code" onChange={handleChange} placeholder="ZIP Code" name="zip_code"  value={formData.zip_code || ''}/>
            </SoftBox>
          </Grid>
          <Grid item xs={6}>
            <SoftBox>
              <FormField label="Phone Number" onChange={handleChange} placeholder="Phone Number" name="phone_number"  value={formData.phone_number || ''}/>
            </SoftBox>
          </Grid>
          <Grid item xs={6}>
            <SoftBox>
              <FormField label="Time Zone" onChange={handleChange} placeholder="Time Zone" name="time_zone"  value={formData.time_zone || ''}/>
            </SoftBox>
          </Grid>
        </Grid>
        <SoftBox mt={4}>
          <SoftButton type="submit" color="dark"   fullWidth>
            Update
          </SoftButton>
        </SoftBox>

      </SoftBox>
    </MDModal>
  );
}
ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  products: PropTypes.array,
  apps: PropTypes.array,
  data: PropTypes.array,
  handleRefresh: PropTypes.func,
};
function Modal({ products,apps ,data,handleRefresh}) {
  const [openAddMember, setOpenAddMember] = useState(false);

  return (
    <>
      <SoftButton
        variant="contained"
        color="info"
        size="small"
        onClick={() => setOpenAddMember(true)}
      >
        Edit
      </SoftButton>
      <ModalComponent
        open={openAddMember}
        onClose={() => setOpenAddMember(false)}
        products={products}
        data={data}
        apps={apps}
        handleRefresh={handleRefresh}
      />
    </>
  );
}
Modal.propTypes = {
  products: PropTypes.array,
  apps: PropTypes.array,
  data: PropTypes.array,
  handleRefresh: PropTypes.func,
};
export default Modal;
